<template>
  <div><slot></slot></div>
</template>

<script>
export default {
  name: 'GuestLayout'
};
</script>

<style></style>
